import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { formErrorRules } from "../../shared/utils/form-error-rules";
import { useStyles } from "./AccountSelect.style";
import FormLayoutHeader from "../../layoutComponents/FormLayout/FormLayoutHeader";

export interface AccountSelectProps {
	users: string[];
	defaultValue: string;
}

const AccountSelect = ({ users, defaultValue }: AccountSelectProps) => {
	const { control } = useFormContext();
	let checkedUser = users[0];
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const styles = useStyles();

	useEffect(() => {
		setIsLoading(false);
	}, [users]);

	return (
		<div>
			<FormLayoutHeader title="Ověření" />
			<Box sx={{ padding: "1rem", marginBottom: "1rem" }}>
				{isLoading ? (
					<span>Loading</span>
				) : (
					<Box>
						<p>
							<strong>VYBERTE ÚČET</strong>
						</p>
						<Typography mt={2}>Bylo nalezeno více účtů. Prosím, vyberte ten, pro který chcete změnu hesla provést.</Typography>
						<Box
							sx={{
								padding: "1rem",
								marginTop: "0.5rem",
								gap: "3rem",
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-between",
							}}
						>
							<div>
								<Controller
									name="account"
									rules={formErrorRules("account")}
									control={control}
									defaultValue={defaultValue}
									render={({ field }) => (
										<RadioGroup {...field}>
											{users.map((user) => {
												return (
													<FormControlLabel
														className={styles.mt}
														key={user}
														value={user}
														control={<Radio size="small" />}
														label={user}
													/>
												);
											})}
										</RadioGroup>
									)}
								/>
							</div>

							<div className={styles.iconAccount}>
								{/*<svg width="60" height="60" viewBox="0 0 90 90" fill="none">*/}
								{/*    <path d="M44.755 0.660919C32.4709 0.660919 22.4202 13.1684 22.4202 28.5794C22.4202 43.9904 32.4709 56.4978 44.755 56.4978C57.0391 56.4978 67.0898 43.9904 67.0898 28.5794C67.0898 13.1684 57.0391 0.660919 44.755 0.660919ZM21.4152 56.4978C9.57773 57.0562 0.0854492 66.7718 0.0854492 78.8326V90H89.4245V78.8326C89.4245 66.7718 80.0439 57.0562 68.0948 56.4978C62.0644 63.3099 53.8006 67.6652 44.755 67.6652C35.7094 67.6652 27.4455 63.3099 21.4152 56.4978Z" fill="black"/>*/}
								{/*</svg>*/}
								<svg width="106" height="89" viewBox="0 0 106 89" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M72.875 0C66.1175 0 60.2875 3.88889 56.71 9.77778C62.6725 15.7778 66.25 24 66.25 33.4444C66.25 36.6667 65.8525 39.5556 65.0575 42.4444C67.575 43.6667 70.0925 44.5556 72.875 44.5556C83.8725 44.5556 92.75 34.5556 92.75 22.3333C92.75 10.1111 83.8725 0.111111 72.875 0.111111V0ZM33.125 11.1111C22.1275 11.1111 13.25 21.1111 13.25 33.3333C13.25 45.5556 22.1275 55.5556 33.125 55.5556C44.1225 55.5556 53 45.5556 53 33.3333C53 21.1111 44.1225 11.1111 33.125 11.1111ZM96.0625 46.2222C90.365 51.8889 82.5475 55.3333 73.67 55.5556C77.2475 59.7778 79.5 64.8889 79.5 70.4444V77.7778H106V59.3333C106 53.5556 101.892 48.5556 96.0625 46.1111V46.2222ZM9.9375 57.3333C4.1075 59.7778 0 64.7778 0 70.5556V89H66.25V70.5556C66.25 64.7778 62.1425 59.7778 56.3125 57.3333C50.35 63.2222 42.2675 66.6667 33.125 66.6667C23.9825 66.6667 15.9 63.1111 9.9375 57.3333Z"
										fill="black"
									/>
								</svg>
							</div>
						</Box>
					</Box>
				)}
			</Box>
		</div>
	);
};

export default AccountSelect;
